import React, { useEffect, useRef, useState } from "react";
import "./AlternativeViews.css";
import { formatNanooxTimestamp } from "../nanooxDateTime";
// import { useI18n } from "../../../context/I18nContext";

const FALLBACK_TIMESTAMP = "--";

const GENERATOR_TRANSLATION_FALLBACKS = {
  ui: {
    title: "Generador",
    detectedGenerators: "Detectados: {{count}}",
    showDetail: "Ver detalle",
    hideDetail: "Ocultar detalle",
    favorite: "Favorito {{label}}",
    updated: "Actualizado: {{value}}",
    operationalStatus: "Estado operativo",
    operationalSummary: "Resumen inmediato del generador y la red",
    communicating: "Comunicando",
    noCommunication: "Sin comunicacion",
    modeAndAvailability: "Modo y disponibilidad",
    modeAndAvailabilitySummary: "Modo activo, disponibilidad y horas de operacion",
    runtimeHours: "Horas ejecucion",
    detected: "Detectado",
    noFault: "Sin falla",
    alarmsTitle: "Alarmas",
    alarmsSummary: "Condiciones criticas y advertencias del controlador",
    activeCount: "{{count}} activas",
    noAlarms: "Sin alarmas",
    ecuCommDiagnosis: "Diagnostico de comunicacion ECU",
    active: "Activo",
    standby: "Espera",
    noMode: "Sin modo",
    fuel: "Combustible",
    currentLevel: "Nivel actual",
    estimatedAutonomy: "Autonomia estimada",
    totalConsumption: "Consumo total",
    status: "Estado",
    fuelStatusTooltip: "Basado en Fuel level: Critico <= 15%, Reserva <= 40%, Estable > 40%.",
    fuelStatusCritical: "Critico",
    fuelStatusReserve: "Reserva",
    fuelStatusStable: "Estable",
    phnVoltage: "Ph-N [V]",
    phphVoltage: "Ph-Ph [V]",
    currentChart: "Current [A]",
    booleanTrue: "Si",
    booleanFalse: "No",
    runtimeYearUnit: "anios",
    runtimeDayUnit: "dias",
    runtimeHourUnit: "h",
    runtimeMinuteUnit: "min",
    fuelTrendEstimatedConsumption: "Tendencia estimada de consumo",
    fuelTrendLiters: "Litros",
    fuelTrendLevel: "Nivel %",
    noGeneratorsTitle: "Sin datos de generador",
    noGeneratorsSummary:
      "El centro no ha reportado lectura de generador. Se mostraran aqui apenas lleguen datos del generador.",
  },
  sections: {
    Estado: "Estado",
    Modos: "Modos",
    Energia: "Energia",
    Generador: "Generador",
    Red: "Red",
    Sistema: "Sistema",
    Control: "Control",
    Breakers: "Breakers",
    Alarmas: "Alarmas",
    ECU: "ECU",
    Motor: "Motor",
    Sensores: "Sensores",
    Proteccion: "Proteccion",
  },
  sectionDescriptions: {
    Estado: "Comunicacion y operacion del generador",
    Modos: "Modo actual del controlador",
    Energia: "Potencia, carga y energia acumulada",
    Generador: "Salida electrica del grupo",
    Red: "Referencia y presencia de red",
    Sistema: "IP, bateria, combustible y diagnostico base",
    Control: "Secuencia de arranque y actuadores",
    Breakers: "Estado y mando de breakers",
    Alarmas: "Eventos criticos y advertencias",
    ECU: "Alertas y estado del modulo ECU",
    Motor: "Funciones auxiliares del motor",
    Sensores: "Entradas digitales y sensores externos",
    Proteccion: "Protecciones electricas del sistema",
  },
  helpers: {
    "Enlace con el controlador": "Enlace con el controlador",
    "Generador encendido": "Generador encendido",
    "Proceso de arranque": "Proceso de arranque",
    "Condicion general del grupo": "Condicion general del grupo",
    "Disponibilidad de red": "Disponibilidad de red",
    "Entregando energia a la carga": "Entregando energia a la carga",
    "Post parada y enfriamiento": "Post parada y enfriamiento",
    "Disponible para operar": "Disponible para operar",
    "Preparado para transferencia": "Preparado para transferencia",
    "Listo para energizar carga": "Listo para energizar carga",
    "Fuera de modo automatico": "Fuera de modo automatico",
    "Comunicacion ECU correcta": "Comunicacion ECU correcta",
    "Rele ECU activo": "Rele ECU activo",
    "Esperando arranque": "Esperando arranque",
    "...": "...",
  },
  labels: {
    connected: "Conectado",
    Comunicacion: "Comunicacion",
    "En Marcha": "En Marcha",
    Ejecutando: "Ejecutando",
    "Generador OK": "Generador OK",
    "Red OK": "Red OK",
    "Alimentando carga": "Alimentando carga",
    Enfriando: "Enfriando",
    Listo: "Listo",
    "Listo para AMF": "Listo para AMF",
    "Listo Para Cargar": "Listo Para Cargar",
    "No en Auto": "No en Auto",
    "Comunicacion ECU OK": "Comunicacion ECU OK",
    "ECU OK": "ECU OK",
    "ECU Rele Potencia": "ECU Rele Potencia",
    "ECU Relé de Potencia": "ECU Rele Potencia",
    "ECU espera Start": "ECU espera Start",
    "ECU Esperar para Start": "ECU Esperar para Start",
    "Falla Comun Modulo periférico": "Falla Comun Modulo periferico",
    "Frecuencia Generador": "Frecuencia Generador",
    "Frecuencia Red": "Frecuencia Red",
    "Modo OFF": "Modo OFF",
    "Modo MAN": "Modo MAN",
    "Modo TEST": "Modo TEST",
    "Modo AUTO": "Modo AUTO",
    Alarma: "Alarma",
    Sirena: "Sirena",
    "Fallo de Red": "Fallo de Red",
    "Voltaje Red": "Voltaje Red",
    "Alarma Nivel 1": "Alarma Nivel 1",
    "Alarma Nivel 2": "Alarma Nivel 2",
    "AL Gen Frec WRN": "AL Gen Frec WRN",
    "AL Gen Frecuencia": "AL Gen Frecuencia",
    "AL Fallo de Red": "AL Fallo de Red",
    "AL Frecuencia Red": "AL Frecuencia Red",
    "AL Voltaje de red": "AL Voltaje de red",
    "AL comun WRN": "AL comun WRN",
    "AL común WRN": "AL comun WRN",
    "AL comun BOC": "AL comun BOC",
    "AL común BOC": "AL comun BOC",
    "AL comun FLS": "AL comun FLS",
    "AL común FLS": "AL comun FLS",
    "E-STOP": "E-STOP",
    "ECU Comm Fail": "ECU Comm Fail",
    RPM: "RPM",
    "P Carga": "P Carga",
    "P Carga L1": "P Carga L1",
    "P Carga L2": "P Carga L2",
    "P Carga L3": "P Carga L3",
    "Q Carga": "Q Carga",
    "Q Carga L1": "Q Carga L1",
    "Q Carga L2": "Q Carga L2",
    "Q Carga L3": "Q Carga L3",
    "S Carga": "S Carga",
    "S Carga L1": "S Carga L1",
    "S Carga L2": "S Carga L2",
    "S Carga L3": "S Carga L3",
    "Factor de potencia de carga": "Factor de potencia de carga",
    "Factor de potencia de carga L1": "Factor de potencia de carga L1",
    "Factor de potencia de carga L2": "Factor de potencia de carga L2",
    "Factor de potencia de carga L3": "Factor de potencia de carga L3",
    "Frecuencia del generador": "Frecuencia del generador",
    "Frecuencia de Red": "Frecuencia de Red",
    "Group kWh": "Group kWh",
    "Group kVArh": "Group kVArh",
    "Horas en Ejecucion": "Horas en Ejecucion",
    "Voltaje de generador L1-N": "Voltaje de generador L1-N",
    "Voltaje de generador L2-N": "Voltaje de generador L2-N",
    "Voltaje de generador L3-N": "Voltaje de generador L3-N",
    "Voltaje de generador L1-L2": "Voltaje de generador L1-L2",
    "Voltaje de generador L2-L3": "Voltaje de generador L2-L3",
    "Voltaje de generador L3-L1": "Voltaje de generador L3-L1",
    "Corriente de carga L1": "Corriente de carga L1",
    "Corriente de carga L2": "Corriente de carga L2",
    "Corriente de carga L3": "Corriente de carga L3",
    "Voltaje de Red L1-N": "Voltaje de Red L1-N",
    "Voltaje de Red L2-N": "Voltaje de Red L2-N",
    "Voltaje de Red L3-N": "Voltaje de Red L3-N",
    "Voltaje de Red L1-L2": "Voltaje de Red L1-L2",
    "Voltaje de Red L2-L3": "Voltaje de Red L2-L3",
    "Voltaje de Red L3-L1": "Voltaje de Red L3-L1",
    "Red kWh": "Red kWh",
    "Red kVArh": "Red kVArh",
    "Fuel level": "Fuel level",
    "Consumo total de combustible": "Consumo total de combustible",
    "Voltaje de la bateria": "Voltaje de la bateria",
    Manual: "Manual",
    Latido: "Latido",
    "Cambio de Temperatura": "Cambio de Temperatura",
    "Regeneración Necesaria": "Regeneracion Necesaria",
    "Botón Reseteo": "Boton Reseteo",
    "Bloqueo IntroContraseña": "Bloqueo IntroContrasena",
    "D+": "D+",
    "Tiempo hasta Vaciarce(Dias)": "Tiempo hasta Vaciarce(Dias)",
    "Tiempo hasta Vaciarce(hrs)": "Tiempo hasta Vaciarce(hrs)",
    "Tiempo hasta Vaciarce(min)": "Tiempo hasta Vaciarce(min)",
    "Arranque 1": "Arranque 1",
    "Arranque 2": "Arranque 2",
    Ignición: "Ignicion",
    "Ignición ON": "Ignicion ON",
    PreStart: "PreStart",
    "Solenoide del Combustible": "Solenoide del Combustible",
    "Bomba de Combustible": "Bomba de Combustible",
    "Bomba de Refrigeración": "Bomba de Refrigeracion",
    "Válvula de Aire": "Valvula de Aire",
    "Stop Válvula del Solenoide": "Stop Valvula del Solenoide",
    "Pulso de Stop": "Pulso de Stop",
    "Ralentí/Nominal": "Ralenti/Nominal",
    "Estado MCB": "Estado MCB",
    "Estado del GCB": "Estado del GCB",
    "Cerrar/Abrir GCB": "Cerrar/Abrir GCB",
    "Cerrar/Abrir MCB": "Cerrar/Abrir MCB",
    "Bobina ON GCB": "Bobina ON GCB",
    "Bobina OFF GCB": "Bobina OFF GCB",
    "Bobina UV GCB": "Bobina UV GCB",
    "Bobina ON MCB": "Bobina ON MCB",
    "Bobina OFF MCB": "Bobina OFF MCB",
    "Bobina UV MCB": "Bobina UV MCB",
    "Sobrevoltaje Red L1": "Sobrevoltaje Red L1",
    "Bajo Voltaje Red L1": "Bajo Voltaje Red L1",
    "Sobrevoltaje Red L2": "Sobrevoltaje Red L2",
    "Bajo Voltaje Red L2": "Bajo Voltaje Red L2",
    "Sobrevoltaje Red L3": "Sobrevoltaje Red L3",
    "Bajo Voltaje Red L3": "Bajo Voltaje Red L3",
    "ECU Communication Error": "ECU Communication Error",
    "ECU Luz Roja": "ECU Luz Roja",
    "ECU Luz Amarilla": "ECU Luz Amarilla",
    "ATT HEST Lámpara": "ATT HEST Lampara",
    "ATT High Soot Load": "ATT High Soot Load",
    "ATT DEF Nivel Lampara": "ATT DEF Nivel Lampara",
    "ATT DPF Lamp": "ATT DPF Lamp",
    "ATT SCR Error Lampara": "ATT SCR Error Lampara",
    "ATT Regen ACK Lampara": "ATT Regen ACK Lampara",
    "ATT Lampara inhibida": "ATT Lampara inhibida",
    "ATT Inhibir Regen Activo": "ATT Inhibir Regen Activo",
    "ATT Forzar Regen Activo": "ATT Forzar Regen Activo",
    "Ventilación": "Ventilacion",
    "Pulso Enc. Ventilación": "Pulso Enc. Ventilacion",
    "Pulso Apag. Ventilación": "Pulso Apag. Ventilacion",
    Choke: "Choke",
    "Switch AIN 01": "Switch AIN 01",
    "Switch AIN 02": "Switch AIN 02",
    "Switch AIN 03": "Switch AIN 03",
    "Switch AIN 04": "Switch AIN 04",
    "Switch AIN 05": "Switch AIN 05",
    "Switch AIN 06": "Switch AIN 06",
    "Switch AIN 10": "Switch AIN 10",
    Sobrecarga: "Sobrecarga",
    "Corto Circuito": "Corto Circuito",
    "Sobrecorriente IDMT": "Sobrecorriente IDMT",
    "Potencia Inversa": "Potencia Inversa",
    "Desbalance corriente": "Desbalance corriente",
    "Desbalance Voltaje": "Desbalance Voltaje",
    ip: "IP",
  },
};

function interpolateTemplate(template, params = {}) {
  if (typeof template !== "string" || !params || typeof params !== "object") {
    return template;
  }

  return Object.entries(params).reduce((result, [key, value]) => {
    const stringValue = String(value);
    return result
      .replaceAll(`{{${key}}}`, stringValue)
      .replaceAll(`{${key}}`, stringValue);
  }, template);
}

function getNestedFallback(path) {
  return path.split(".").reduce((current, part) => (current && typeof current === "object" ? current[part] : undefined), GENERATOR_TRANSLATION_FALLBACKS);
}

function pickResolvedTranslation(candidates = []) {
  for (const candidate of candidates) {
    if (!candidate || candidate.value === undefined || candidate.value === null) continue;

    if (typeof candidate.value === "string") {
      if (!candidate.misses?.includes(candidate.value)) {
        return candidate.value;
      }
      continue;
    }

    return candidate.value;
  }

  return undefined;
}

const SECTION_DEFINITIONS = [
  {
    title: "Estado",
    items: [
      "connected",
      "En Marcha",
      "Ejecutando",
      "Generador OK",
      "Red OK",
      "Alimentando carga",
      "Enfriando",
      "Listo",
      "Listo para AMF",
      "Listo Para Cargar",
      "No en Auto",
      "Comunicacion ECU OK",
      "ECU Relé de Potencia",
      "ECU Esperar para Start",
      "Falla Comun Modulo periférico",
    ],
  },
  // {
  //   title: "Modos",
  //   items: ["Modo OFF", "Modo MAN", "Modo TEST", "Modo AUTO"],
  // },
  {
    title: "Energia",
    items: [
      "RPM",
      "P Carga",
      "P Carga L1",
      "P Carga L2",
      "P Carga L3",
      "Q Carga",
      "Q Carga L1",
      "Q Carga L2",
      "Q Carga L3",
      "S Carga",
      "S Carga L1",
      "S Carga L2",
      "S Carga L3",
      "Factor de potencia de carga",
      "Factor de potencia de carga L1",
      "Factor de potencia de carga L2",
      "Factor de potencia de carga L3",
      "Frecuencia del generador",
      "Group kWh",
      "Group kVArh",
      "Horas en Ejecucion",
    ],
  },
  {
    title: "Generador",
    items: [
      "Voltaje de generador L1-N",
      "Voltaje de generador L2-N",
      "Voltaje de generador L3-N",
      "Voltaje de generador L1-L2",
      "Voltaje de generador L2-L3",
      "Voltaje de generador L3-L1",
      "Corriente de carga L1",
      "Corriente de carga L2",
      "Corriente de carga L3",
    ],
  },
  {
    title: "Red",
    items: [
      "Frecuencia de Red",
      "Voltaje de Red L1-N",
      "Voltaje de Red L2-N",
      "Voltaje de Red L3-N",
      "Voltaje de Red L1-L2",
      "Voltaje de Red L2-L3",
      "Voltaje de Red L3-L1",
      "Red kWh",
      "Red kVArh",
    ],
  },
  {
    title: "Sistema",
    items: [
      "Manual",
      "Latido",
      "Cambio de Temperatura",
      "Regeneración Necesaria",
      "Botón Reseteo",
      "Bloqueo IntroContraseña",
      // "ip",
      "Voltaje de la bateria",
      "D+",
      "Fuel level",
      "Consumo total de combustible",
      "Tiempo hasta Vaciarce(Dias)",
      "Tiempo hasta Vaciarce(hrs)",
      "Tiempo hasta Vaciarce(min)",
    ],
  },
  {
    title: "Control",
    items: [
      "Arranque 1",
      "Arranque 2",
      "Ignición",
      "Ignición ON",
      "PreStart",
      "Solenoide del Combustible",
      "Bomba de Combustible",
      "Bomba de Refrigeración",
      "Válvula de Aire",
      "Stop Válvula del Solenoide",
      "Pulso de Stop",
      "Ralentí/Nominal",
    ],
  },
  {
    title: "Breakers",
    items: [
      "Estado MCB",
      "Estado del GCB",
      "Cerrar/Abrir GCB",
      "Cerrar/Abrir MCB",
      "Bobina ON GCB",
      "Bobina OFF GCB",
      "Bobina UV GCB",
      "Bobina ON MCB",
      "Bobina OFF MCB",
      "Bobina UV MCB",
    ],
  },
  {
    title: "Alarmas",
    items: [
      "Alarma",
      "Sirena",
      "Fallo de Red",
      "Frecuencia Red",
      "Voltaje Red",
      "Sobrevoltaje Red L1",
      "Bajo Voltaje Red L1",
      "Sobrevoltaje Red L2",
      "Bajo Voltaje Red L2",
      "Sobrevoltaje Red L3",
      "Bajo Voltaje Red L3",
      "Frecuencia Generador",
      "Alarma Nivel 1",
      "Alarma Nivel 2",
      "AL Gen Frec WRN",
      "AL Gen Frecuencia",
      "AL Fallo de Red",
      "AL Frecuencia Red",
      "AL Voltaje de red",
      "AL común WRN",
      "AL común BOC",
      "AL común FLS",
      "E-STOP",
    ],
  },
  {
    title: "ECU",
    items: [
      "ECU Comm Fail",
      "ECU Communication Error",
      "ECU Luz Roja",
      "ECU Luz Amarilla",
      "ATT HEST Lámpara",
      "ATT High Soot Load",
      "ATT DEF Nivel Lampara",
      "ATT DPF Lamp",
      "ATT SCR Error Lampara",
      "ATT Regen ACK Lampara",
      "ATT Lampara inhibida",
      "ATT Inhibir Regen Activo",
      "ATT Forzar Regen Activo",
    ],
  },
  {
    title: "Motor",
    items: ["Ventilación", "Pulso Enc. Ventilación", "Pulso Apag. Ventilación", "Choke"],
  },
  {
    title: "Sensores",
    items: ["Switch AIN 01", "Switch AIN 02", "Switch AIN 03", "Switch AIN 04", "Switch AIN 05", "Switch AIN 06", "Switch AIN 10"],
  },
  {
    title: "Proteccion",
    items: [
      "Sobrecarga",
      "Corto Circuito",
      "Sobrecorriente IDMT",
      "Potencia Inversa",
      "Desbalance corriente",
      "Desbalance Voltaje",
    ],
  },
];

const SECTION_HIGHLIGHTS = {
  Estado:           ["connected", "En Marcha", "Generador OK"],
  Modos:            ["Modo OFF", "Modo MAN", "Modo AUTO"],
  Energia:          ["RPM", "P Carga", "Group kWh"],
  Generador:        ["Voltaje de generador L1-N", "Voltaje de generador L1-L2", "Corriente de carga L1"],
  Red:              ["Frecuencia de Red", "Voltaje de Red L1-N", "Red kWh"],
  Sistema:          ["ip", "Voltaje de la bateria", "Fuel level"],
  Control:          ["Arranque 1", "Ignición", "PreStart"],
  Breakers:         ["Estado MCB", "Estado del GCB", "Cerrar/Abrir GCB"],
  Alarmas:          ["Alarma", "Fallo de Red", "Alarma Nivel 1"],
  ECU:              ["ECU Comm Fail", "ATT HEST Lámpara", "ATT High Soot Load"],
  Motor:            ["Ventilación", "Choke", "Pulso Enc. Ventilación"],
  Sensores:         ["Switch AIN 01-10"],
  Proteccion:       ["Sobrecarga", "Corto Circuito", "Potencia Inversa"],
  "Estado del GCB": ["Estado del GCB", "Cerrar/Abrir GCB"],
  "Estado MCB":     ["Estado MCB", "Cerrar/Abrir MCB"],
  "E-STOP":         ["E-STOP", "ECU Ejecutar Stop"],
};

const SECTION_META = {
  Estado:    { icon: "S", accent: "green",  description: "Comunicacion y operacion del generador" },
  Modos:     { icon: "M", accent: "blue",   description: "Modo actual del controlador" },
  Energia:   { icon: "E", accent: "blue",   description: "Potencia, carga y energia acumulada" },
  Generador: { icon: "G", accent: "green",  description: "Salida electrica del grupo" },
  Red:       { icon: "R", accent: "cyan",   description: "Referencia y presencia de red" },
  Sistema:   { icon: "I", accent: "amber",  description: "IP, bateria, combustible y diagnostico base" },
  Control:   { icon: "C", accent: "slate",  description: "Secuencia de arranque y actuadores" },
  Breakers:  { icon: "B", accent: "cyan",   description: "Estado y mando de breakers" },
  Alarmas:   { icon: "!", accent: "orange", description: "Eventos criticos y advertencias" },
  ECU:       { icon: "U", accent: "orange", description: "Alertas y estado del modulo ECU" },
  Motor:     { icon: "T", accent: "slate",  description: "Funciones auxiliares del motor" },
  Sensores:  { icon: "N", accent: "slate",  description: "Entradas digitales y sensores externos" },
  Proteccion:{ icon: "P", accent: "orange", description: "Protecciones electricas del sistema" },
};

const DEFAULT_FAVORITE_LABELS = [
  "RPM",
  "Frecuencia del generador",
  "Group kWh",
  "Horas en Ejecucion",
];

const KPI_STORAGE_KEY = "nanoox-generator-kpis-v1";
const DETAIL_STORAGE_KEY = "nanoox-generator-detail-order-v1";

const SECTION_TITLE_TRANSLATION_KEYS = {
  Estado: "generatorSectionEstado",
  Modos: "generatorSectionModos",
  Energia: "generatorSectionEnergia",
  Generador: "generatorSectionGenerador",
  Red: "generatorSectionRed",
  Sistema: "generatorSectionSistema",
  Control: "generatorSectionControl",
  Breakers: "generatorSectionBreakers",
  Alarmas: "generatorSectionAlarmas",
  ECU: "generatorSectionECU",
  Motor: "generatorSectionMotor",
  Sensores: "generatorSectionSensores",
  Proteccion: "generatorSectionProteccion",
};

const SOURCE_LABEL_ALIASES = {
  "Tiempo hasta Vaciarce(hrs)":    ["Tiempo hasta Vaciarce(hrs)", "Tiempo hasta Vaciarce(horas)"],
  "Tiempo hasta Vaciarce(min)":    ["Tiempo hasta Vaciarce(min)", "Tiempo hasta Vaciarce(minutos)"],
  "Alimentando carga":             ["Alimentando carga", "Alimentando la Carga"],
  "Comunicacion ECU OK":           ["Comunicacion ECU OK", "Comunicación ECU OK"],
  "ECU Esperar para Start":        ["ECU Esperar para Start", "ECU Wait To Start"],
  "Falla Comun Modulo periférico": ["Falla Comun Modulo periférico"],
  "Fallo de Red":                  ["Fallo de Red", "AL Fallo de Red"],
  "Voltaje Red":                   ["Voltaje Red", "AL Voltaje de red"],
  "Frecuencia Red":                ["Frecuencia Red", "AL Frecuencia Red"],
  "Frecuencia Generador":          ["Frecuencia Generador", "AL Gen Frecuencia", "AL Gen Frec WRN"],
  "Alarma Nivel 1":                ["Alarma Nivel 1", "Alarma común Nivel 1", "Alarma Comun Nivel 1", "Alarma Comun activa Nivel 1"],
  "Alarma Nivel 2":                ["Alarma Nivel 2", "Alarma común Nivel 2", "Alarma Comun Nivel 2", "Alarma Comun activa Nivel 2"],
};

const ORDERED_GENERATOR_LABELS = [
  "ip",
  ...Array.from(new Set(SECTION_DEFINITIONS.flatMap((section) => section.items))),
];

const COMPUTED_LABELS = {
  "Comunicacion ECU OK": (record) => {
    if (record["Comunicacion ECU OK"] !== undefined) {
      return null;
    }
    if (record["ECU Comm Fail"] === undefined) return null;
    return {
      value: !record["ECU Comm Fail"],
      timestamp: record.timestamp || "--",
    };
  },
};

function buildDataset(generatorRecord) {
  if (!generatorRecord || typeof generatorRecord !== "object") {
    return [];
  }

  const generatorTimestamp = generatorRecord.timestamp || FALLBACK_TIMESTAMP;
  const usedSourceLabels = new Set(["timestamp"]);

  const orderedDataset = ORDERED_GENERATOR_LABELS.map((label) => {
    const candidateLabels = SOURCE_LABEL_ALIASES[label] || [label];
    const sourceLabel = candidateLabels.find((candidate) => generatorRecord[candidate] !== undefined);

    if (!sourceLabel) {
      const computed = COMPUTED_LABELS[label]?.(generatorRecord);
      if (computed) {
        return {
          label,
          value: computed.value,
          timestamp: computed.timestamp || generatorTimestamp || "--",
        };
      }

      return {
        label,
        value: "--",
        timestamp: "--",
      };
    }

    usedSourceLabels.add(sourceLabel);
    const source = generatorRecord[sourceLabel];

    if (source && typeof source === "object" && "value" in source) {
      return {
        label,
        value: source.value,
        timestamp: source.timestamp || generatorTimestamp || "--",
      };
    }

    return {
      label,
      value: source,
      timestamp: generatorTimestamp || "--",
    };
  });

  const extraDataset = Object.entries(generatorRecord)
    .filter(([label]) => !usedSourceLabels.has(label))
    .map(([label, value]) => ({
      label,
      value,
      timestamp: generatorTimestamp || "--",
    }));

  return [...orderedDataset, ...extraDataset];
}

export function resolveGeneratorRecord(generator) {
  if (!generator || typeof generator !== "object") {
    return null;
  }

  if (Array.isArray(generator.monitor_data)) {
    return generator.monitor_data[0] ?? null;
  }

  // COMAP entrega el snapshot directamente bajo
  // generators_comap.generators.<generator_name>.
  return generator;
}

function getValue(dataset, label) {
  return dataset.find((item) => item.label === label)?.value ?? "--";
}

function getTimestamp(dataset, label) {
  return dataset.find((item) => item.label === label)?.timestamp ?? "--";
}

function toFiniteNumber(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function formatValue(label, value, t) {
  if (value === null || value === undefined || value === "") return "--";
  if (typeof value === "number" && Number.isNaN(value)) return "--";
  if (typeof value === "boolean") {
    if (!t) return value ? "True" : "False";
    return value ? t("booleanTrue") : t("booleanFalse");
  }
  if (typeof value === "string" && ["nan", "undefined", "null"].includes(value.toLowerCase())) return "--";
  if (label === "Fuel level") return `${value} %`;
  if (label === "Voltaje de la bateria") return `${(toFiniteNumber(value, 0) / 10).toFixed(1)} V`;
  if (label === "Frecuencia del generador" || label === "Frecuencia de Red") {
    return `${(toFiniteNumber(value, 0) / 10).toFixed(1)} Hz`;
  }
  if (label.startsWith("Voltaje de generador") || label.startsWith("Voltaje de Red")) {
    return `${value} V`;
  }
  if (label.startsWith("Corriente de carga")) return `${value} A`;
  if (label === "P Carga" || label.startsWith("P Carga ")) return `${value} kW`;
  if (label === "Q Carga" || label.startsWith("Q Carga ")) return `${value} kVAr`;
  if (label === "S Carga" || label.startsWith("S Carga ")) return `${value} kVA`;
  if (label === "Group kWh" || label === "Red kWh") return `${value} kWh`;
  if (label === "Group kVArh" || label === "Red kVArh") return `${value} kVArh`;
  if (label === "Horas en Ejecucion") return `${value} h`;
  if (label === "Consumo total de combustible") return `${value} L`;
  return `${value}`;
}

function getSectionTimestamp(dataset, items) {
  const timestamps = items
    .map((label) => getTimestamp(dataset, label))
    .filter((value) => value && value !== "--");

  return timestamps[0] || "--";
}

function buildSectionHighlights(section, dataset) {
  const preferred = SECTION_HIGHLIGHTS[section.title] || section.items.slice(0, 3);

  return preferred
    .filter((label) => section.items.includes(label))
    .map((label) => ({
      label,
      value: formatValue(label, getValue(dataset, label)),
    }));
}

function getHighlightTone(label, rawValue) {
  const numericValue = toFiniteNumber(rawValue, 0);

  if (label === "connected") {
    return rawValue === true ? "good" : "critical";
  }

  if (label === "Fuel level") {
    if (numericValue <= 20) return "critical";
    if (numericValue <= 40) return "warn";
    return "good";
  }

  if (label === "Voltaje de la bateria") {
    if (numericValue <= 240) return "critical";
    if (numericValue <= 265) return "warn";
    return "good";
  }

  if (label === "P Carga" || label === "S Carga" || label === "Q Carga") {
    if (numericValue === 0) return "muted";
    return "good";
  }

  if (label.startsWith("Frecuencia")) {
    if (numericValue === 0) return "muted";
    return "good";
  }

  return "default";
}

function getTooltipPlacement(pointerX, pointerY, limits = {}) {
  const {
    left = 18,
    right = 78,
    top = 18,
    bottom = 84,
  } = limits;

  let sideX = "right";
  let sideY = "top";

  if (pointerX >= right) sideX = "left";
  if (pointerX <= left) sideX = "right";
  if (pointerY <= top) sideY = "bottom";
  if (pointerY >= bottom) sideY = "top";

  return { sideX, sideY };
}

function getBooleanTone(value, inverse = false) {
  if (inverse) {
    return value ? "alert" : "ok";
  }

  return value ? "ok" : "muted";
}

function StatusPill({ label, value, helper, inverse = false }) {
  const tone = getBooleanTone(value, inverse);

  return (
    <div className={`generator-status-pill tone-${tone}`}>
      <div className="generator-status-pill-head">
        <span className="generator-status-dot" />
        <strong>{label}</strong>
      </div>
      {/* <span className="generator-status-pill-value">{!value ? "Activo" : "Inactivo"}</span> */}
      {helper ? <small>{helper}</small> : null}
    </div>
  );
}

function ModeBadge({ label, active, activeLabel = "Activo", standbyLabel = "Espera" }) {
  return (
    <div className={`generator-mode-badge ${active ? "active" : ""}`}>
      <span>{label}</span>
      <strong>{active ? activeLabel : standbyLabel}</strong>
    </div>
  );
}

function sortItemsByStatusAndLabel(items = []) {
  return [...items].sort((a, b) => {
    // Activos primero
    if (a.value !== b.value) {
      return Number(b.value) - Number(a.value);
    }

    // Luego orden alfabético
    return a.label.localeCompare(b.label, "es", { sensitivity: "base" });
  });
}

function formatRuntimeBreakdown(value, t) {
  const totalHours = toFiniteNumber(value, 0);

  if (!Number.isFinite(totalHours) || totalHours <= 0) return null;
  if (totalHours < 24) return null;

  const hoursPerDay = 24;
  const hoursPerYear = hoursPerDay * 365;

  const years = Math.floor(totalHours / hoursPerYear);
  const hoursAfterYears = totalHours % hoursPerYear;
  const days = Math.floor(hoursAfterYears / hoursPerDay);
  const remainingHours = hoursAfterYears % hoursPerDay;

  const parts = [];

  if (years > 0) {
    parts.push(`${years} ${t("runtimeYearUnit")}`);
  }

  if (days > 0) {
    parts.push(`${days} ${t("runtimeDayUnit")}`);
  }

  if (remainingHours > 0) {
    parts.push(`${remainingHours} ${t("runtimeHourUnit")}`);
  }

  return parts.join(" ");
}

function formatDurationCompact(parts, t) {
  const items = [];

  if (toFiniteNumber(parts.days, 0) > 0) {
    items.push(`${toFiniteNumber(parts.days, 0)} ${t("runtimeDayUnit")}`);
  }

  if (toFiniteNumber(parts.hours, 0) > 0) {
    items.push(`${toFiniteNumber(parts.hours, 0)} ${t("runtimeHourUnit")}`);
  }

  if (toFiniteNumber(parts.minutes, 0) > 0 || !items.length) {
    items.push(`${toFiniteNumber(parts.minutes, 0)} ${t("runtimeMinuteUnit")}`);
  }

  return items.join(" ");
}

function GeneratorOperationalOverview({
  connected,
  hours,
  stateItems = [],
  modeItems = [],
  alarmItems = [],
  ecuCommFail = false,
  t,
  translateLabel,
  translateHelper,
}) {
  const activeMode = modeItems.find((item) => item.value)?.label;
  const activeModeLabel = activeMode ? translateLabel(activeMode) : t("noMode");
  const activeAlarms = alarmItems.filter((item) => item.value);
  const hasActiveAlarm = activeAlarms.length > 0 || ecuCommFail;

  const sortedStateItems = sortItemsByStatusAndLabel(stateItems);
  const sortedAlarmItems = sortItemsByStatusAndLabel(alarmItems);

  return (
    <section className="generator-operational-grid">
      <article className="generator-operational-card">
        <div className="generator-operational-head">
          <div>
            <h3>{t("operationalStatus")}</h3>
            <p>{t("operationalSummary")}</p>
          </div>
          <span className={`generator-operational-badge ${connected ? "ok" : "alert"}`}>
            {connected ? t("communicating") : t("noCommunication")}
          </span>
        </div>
        <div className="generator-status-grid">
          {sortedStateItems.map((item) => (
            <StatusPill
              key={item.label}
              label={translateLabel(item.label)}
              value={item.value}
              helper={translateHelper(item.helper)}
            />
          ))}
        </div>
      </article>

      <article className="generator-operational-card">
        <div className="generator-operational-head">
          <div>
            <h3>{t("modeAndAvailability")}</h3>
            <p>{t("modeAndAvailabilitySummary")}</p>
          </div>
          <span className="generator-operational-emphasis">
            {activeModeLabel}
          </span>
        </div>
        <div className="generator-mode-grid">
          {modeItems.map((item) => (
            <ModeBadge
              key={item.label}
              label={translateLabel(item.label)}
              active={item.value}
              activeLabel={t("active")}
              standbyLabel={t("standby")}
            />
          ))}
        </div>
        <div className="generator-operational-footer">
          <div className="generator-operational-metric">
            <span>{t("runtimeHours")}</span>
            <strong>{formatValue("Horas en Ejecucion", hours, t)}</strong>
            {formatRuntimeBreakdown(hours, t) ? <small>{formatRuntimeBreakdown(hours, t)}</small> : null}
          </div>
          <div className={`generator-operational-metric ${ecuCommFail ? "is-alert" : ""}`}>
            <span>{translateLabel("ECU Comm Fail")}</span>
            <strong>{ecuCommFail ? t("detected") : t("noFault")}</strong>
          </div>
        </div>
      </article>

      <article className="generator-operational-card">
        <div className="generator-operational-head">
          <div>
            <h3>{t("alarmsTitle")}</h3>
            <p>{t("alarmsSummary")}</p>
          </div>
          <span className={`generator-operational-badge ${hasActiveAlarm ? "alert" : "ok"}`}>
            {hasActiveAlarm
              ? t("activeCount", { count: activeAlarms.length + (ecuCommFail ? 1 : 0) })
              : t("noAlarms")}
          </span>
        </div>
        <div className="generator-status-grid compact">
          {sortedAlarmItems.map((item) => (
            <StatusPill
              key={item.label}
              label={translateLabel(item.label)}
              value={item.value}
              inverse
            />
          ))}
          <StatusPill
            label={translateLabel("ECU Comm Fail")}
            value={ecuCommFail}
            inverse
            helper={t("ecuCommDiagnosis")}
          />
        </div>
      </article>
    </section>
  );
}

function buildKpiCards(dataset, favoriteLabels = [], formatter) {
  const labels = favoriteLabels.length ? favoriteLabels : DEFAULT_FAVORITE_LABELS;

  return labels.map((label) => ({
    label,
    value: formatter ? formatter(label, getValue(dataset, label)) : formatValue(label, getValue(dataset, label)),
    timestamp: getTimestamp(dataset, label),
    accent: getLabelAccent(label),
  }));
}

function getLabelAccent(label) {
  const section = SECTION_DEFINITIONS.find((item) => item.items.includes(label));
  return SECTION_META[section?.title]?.accent || "slate";
}

function sanitizeFavoriteLabels(labels = [], selectableLabels = []) {
  const unique = Array.from(new Set(Array.isArray(labels) ? labels : []));
  const filtered = unique.filter((label) => selectableLabels.includes(label));
  return filtered.length ? filtered : DEFAULT_FAVORITE_LABELS.filter((label) => selectableLabels.includes(label));
}

function sanitizeSectionOrder(order = [], availableTitles = []) {
  const unique = Array.from(new Set(Array.isArray(order) ? order : []));
  const filtered = unique.filter((title) => availableTitles.includes(title));
  const missing = availableTitles.filter((title) => !filtered.includes(title));
  return [...filtered, ...missing];
}

function polarToCartesian(cx, cy, radius, angle) {
  const radians = ((angle - 90) * Math.PI) / 180;

  return {
    x: cx + radius * Math.cos(radians),
    y: cy + radius * Math.sin(radians),
  };
}

function describeArc(cx, cy, radius, startAngle, endAngle) {
  const start = polarToCartesian(cx, cy, radius, endAngle);
  const end = polarToCartesian(cx, cy, radius, startAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

  return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`;
}

// function MiniPhaseChart({ title, labels, values, max = 400, unit = "" }) {
//   const yTicks = [0, max * 0.25, max * 0.5, max * 0.75, max];
//   const [tooltip, setTooltip] = useState(null);
//   const width = 200;
//   const height = 170;
//   const axisLeft = 34;
//   const axisBottom = 132;
//   const plotTop = 18;
//   const plotHeight = 98;
//   const pointXs = labels.map((_, index) => 62 + index * 60);

//   const handleMove = (event) => {
//     const svg = event.currentTarget;
//     const rect = svg.getBoundingClientRect();
//     const relativeX = ((event.clientX - rect.left) / rect.width) * width;
//     const nearestIndex = pointXs.reduce((bestIndex, pointX, index) => (
//       Math.abs(pointX - relativeX) < Math.abs(pointXs[bestIndex] - relativeX) ? index : bestIndex
//     ), 0);
//     const pointerX = ((event.clientX - rect.left) / rect.width) * 100;
//     const pointerY = ((event.clientY - rect.top) / rect.height) * 100;
//     const placement = getTooltipPlacement(pointerX, pointerY, { left: 22, right: 76, top: 20, bottom: 84 });

//     setTooltip({
//       x: `${pointerX}%`,
//       y: `${pointerY}%`,
//       label: labels[nearestIndex],
//       value: values[nearestIndex],
//       sideX: placement.sideX,
//       sideY: placement.sideY,
//     });
//   };

//   return (
//     <article className="generator-chart-card">
//       <div className="generator-panel-title">{title}</div>
//       <div className="generator-mini-chart">
//         <div className="generator-mini-chart-grid" />
//         {tooltip ? (
//           <div
//             className={`generator-chart-tooltip ${tooltip.sideX === "left" ? "flip-x" : ""} ${tooltip.sideY === "bottom" ? "flip-y" : ""}`}
//             style={{ left: tooltip.x, top: tooltip.y }}
//           >
//             {tooltip.label}: {tooltip.value}{unit}
//           </div>
//         ) : null}
//         <svg
//           viewBox={`0 0 ${width} ${height}`}
//           className="generator-mini-chart-svg"
//           aria-hidden="true"
//           onMouseMove={handleMove}
//           onMouseLeave={() => setTooltip(null)}
//         >
//           <line x1={axisLeft} y1={plotTop} x2={axisLeft} y2={axisBottom} className="generator-chart-axis" />
//           <line x1={axisLeft} y1={axisBottom} x2="206" y2={axisBottom} className="generator-chart-axis" />

//           {yTicks.map((tick) => {
//             const y = axisBottom - (tick / max) * plotHeight;

//             return (
//               <g key={`${title}-y-${tick}`}>
//                 <line x1={axisLeft - 4} y1={y} x2={axisLeft} y2={y} className="generator-chart-axis-tick" />
//                 <text x={axisLeft - 8} y={y + 3} textAnchor="end" className="generator-chart-y-label">
//                   {tick}
//                 </text>
//               </g>
//             );
//           })}

//           {values.map((value, index) => {
//             const x = 62 + index * 60;
//             const y = axisBottom - Math.max(0, Math.min(1, toFiniteNumber(value, 0) / max)) * plotHeight;

//             return (
//               <g key={`${title}-${labels[index]}`}>
//                 <line x1={x} y1={axisBottom} x2={x} y2={plotTop + 6} className="generator-chart-guide" />
//                 <line x1={axisLeft} y1={y} x2={x + 12} y2={y} className="generator-chart-value" />
//                 <polygon points={`${x + 16},${y} ${x + 8},${y - 6} ${x + 8},${y + 6}`} className="generator-chart-arrow" />
//                 <text x={x} y="154" textAnchor="middle" className="generator-chart-label">
//                   {labels[index]}
//                 </text>
//               </g>
//             );
//           })}
//         </svg>
//       </div>
//     </article>
//   );
// }
function MiniPhaseChart({ title, labels, values, max = 400, unit = "" }) {
  const yTicks = [0, max * 0.25, max * 0.5, max * 0.75, max];
  const [tooltip, setTooltip] = useState(null);

  const width = 320;
  const height = 170;

  const axisLeft = 30;
  const axisRight = width - 12;
  const axisBottom = 132;
  const plotTop = 18;
  const plotHeight = 98;
  const plotWidth = axisRight - axisLeft;
  const segmentWidth = labels.length > 0 ? plotWidth / (labels.length + 1) : plotWidth;
  const pointXs = labels.map((_, index) => axisLeft + segmentWidth * (index + 1));

  // const pointXs = labels.map((_, index) => {
  //   if (labels.length === 1) return axisLeft + plotWidth / 2;
  //   return axisLeft + (index * plotWidth) / (labels.length - 1);
  // });


  const handleMove = (event) => {
    if (!labels.length || !values.length) {
      setTooltip(null);
      return;
    }

    const svg = event.currentTarget;
    const rect = svg.getBoundingClientRect();

    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;

    const svgX = (mouseX / rect.width) * width;

    const nearestIndex = pointXs.reduce((bestIndex, pointX, index) => {
      return Math.abs(pointX - svgX) < Math.abs(pointXs[bestIndex] - svgX)
        ? index
        : bestIndex;
    }, 0);

    const pointerX = (mouseX / rect.width) * 100;
    const pointerY = (mouseY / rect.height) * 100;

    const placement = getTooltipPlacement(pointerX, pointerY, {
      left: 22,
      right: 76,
      top: 20,
      bottom: 84,
    });

    setTooltip({
      x: `${pointerX}%`,
      y: `${pointerY}%`,
      label: labels[nearestIndex],
      value: values[nearestIndex],
      sideX: placement.sideX,
      sideY: placement.sideY,
    });
  };

  return (
    <article className="generator-chart-card">
      <div className="generator-panel-title">{title}</div>
      <div className="generator-mini-chart">
        <div className="generator-mini-chart-grid" />
        {tooltip ? (
          <div
            className={`generator-chart-tooltip ${
              tooltip.sideX === "left" ? "flip-x" : ""
            } ${tooltip.sideY === "bottom" ? "flip-y" : ""}`}
            style={{ left: tooltip.x, top: tooltip.y }}
          >
            {tooltip.label}: {tooltip.value}
            {unit}
          </div>
        ) : null}

        <svg
          viewBox={`0 0 ${width} ${height}`}
          className="generator-mini-chart-svg"
          aria-hidden="true"
          onMouseMove={handleMove}
          onMouseLeave={() => setTooltip(null)}
          preserveAspectRatio="xMidYMid meet"
        >
          <line
            x1={axisLeft}
            y1={plotTop}
            x2={axisLeft}
            y2={axisBottom}
            className="generator-chart-axis"
          />
          <line
            x1={axisLeft}
            y1={axisBottom}
            x2={axisRight}
            y2={axisBottom}
            className="generator-chart-axis"
          />

          {yTicks.map((tick) => {
            const y = axisBottom - (tick / max) * plotHeight;

            return (
              <g key={`${title}-y-${tick}`}>
                <line
                  x1={axisLeft - 4}
                  y1={y}
                  x2={axisLeft}
                  y2={y}
                  className="generator-chart-axis-tick"
                />
                <text
                  x={axisLeft - 8}
                  y={y + 3}
                  textAnchor="end"
                  className="generator-chart-y-label"
                >
                  {tick}
                </text>
              </g>
            );
          })}

          {values.map((value, index) => {
            const x = pointXs[index];
            const y =
              axisBottom -
              Math.max(0, Math.min(1, toFiniteNumber(value, 0) / max)) * plotHeight;

            return (
              <g key={`${title}-${labels[index]}`}>
                <line
                  x1={x}
                  y1={axisBottom}
                  x2={x}
                  y2={plotTop + 6}
                  className="generator-chart-guide"
                />
                <line
                  x1={axisLeft}
                  y1={y}
                  x2={x + 12}
                  y2={y}
                  className="generator-chart-value"
                />
                <polygon
                  points={`${x + 16},${y} ${x + 8},${y - 6} ${x + 8},${y + 6}`}
                  className="generator-chart-arrow"
                />
                <text
                  x={x}
                  y="154"
                  textAnchor="middle"
                  className="generator-chart-y-label"
                >
                  {labels[index]}
                </text>
              </g>
            );
          })}
        </svg>
      </div>
    </article>
  );
}

function buildFuelTrend(level = 0, consumption = 0, days = 0, hours = 0, minutes = 0) {
  const safeLevel = Math.max(0, Math.min(100, toFiniteNumber(level, 0)));
  const safeConsumption = Math.max(0, toFiniteNumber(consumption, 0));
  const totalMinutes = (toFiniteNumber(days, 0) * 24 * 60) + (toFiniteNumber(hours, 0) * 60) + toFiniteNumber(minutes, 0);
  const totalHours = Math.max(1, totalMinutes / 60);
  const points = 6;

  return Array.from({ length: points }, (_, index) => {
    const progress = index / (points - 1);
    const projectedLevel = Math.max(0, safeLevel - (safeLevel * progress));
    const remainingHours = Math.max(0, totalHours * (1 - progress));
    const litersStep = safeLevel > 0 ? (safeConsumption * 0.012) / Math.max(1, points - 1) : 0;
    const projectedLiters = safeConsumption - (litersStep * (points - 1 - index));

    return {
      id: `point-${index}`,
      label: index === points - 1 ? "0h" : `-${Math.round(remainingHours)}h`,
      percentage: Number(projectedLevel.toFixed(1)),
      liters: Number(projectedLiters.toFixed(1)),
    };
  });
}

function FuelTrendChart({ points = [], mode = "percentage", t = (key) => key }) {
  const width = 360;
  const height = 120;
  const left = 28;
  const right = 14;
  const top = 14;
  const bottom = 24;
  const innerWidth = width - left - right;
  const innerHeight = height - top - bottom;

  const maxLiters = Math.max(1, ...points.map((point) => toFiniteNumber(point.liters, 0)));
  const showPercentage = mode === "percentage" || mode === "both";
  const showLiters = mode === "liters" || mode === "both";
  const [tooltip, setTooltip] = useState(null);
  const leftTicks = showPercentage ? [0, 25, 50, 75, 100] : [0, 25, 50, 75, 100];
  const rightTicks = showLiters
    ? [0, 0.25, 0.5, 0.75, 1].map((step) => Math.round(maxLiters * step))
    : [];

  const coords = points.map((point, index) => {
    const x = left + (index / Math.max(1, points.length - 1)) * innerWidth;
    const percentageY = top + (1 - (toFiniteNumber(point.percentage, 0) / 100)) * innerHeight;
    const litersY = top + (1 - (toFiniteNumber(point.liters, 0) / maxLiters)) * innerHeight;

    return { ...point, x, percentageY, litersY };
  });

  const percentagePolyline = coords.map((point) => `${point.x},${point.percentageY}`).join(" ");
  const litersPolyline = coords.map((point) => `${point.x},${point.litersY}`).join(" ");
  const pointXs = coords.map((point) => point.x);

  const handleMove = (event) => {
    const svg = event.currentTarget;
    const rect = svg.getBoundingClientRect();
    const relativeX = ((event.clientX - rect.left) / rect.width) * width;
    const nearestIndex = pointXs.reduce((bestIndex, pointX, index) => (
      Math.abs(pointX - relativeX) < Math.abs(pointXs[bestIndex] - relativeX) ? index : bestIndex
    ), 0);
    const point = coords[nearestIndex];
    const pointerX = ((event.clientX - rect.left) / rect.width) * 100;
    const pointerY = ((event.clientY - rect.top) / rect.height) * 100;
    const placement = getTooltipPlacement(pointerX, pointerY, { left: 18, right: 80, top: 18, bottom: 86 });

    setTooltip({
      x: `${pointerX}%`,
      y: `${pointerY}%`,
      text: showPercentage && showLiters
        ? `${point.label}: ${point.percentage}% / ${Math.round(point.liters)}L`
        : showLiters
          ? `${point.label}: ${Math.round(point.liters)}L`
          : `${point.label}: ${point.percentage}%`,
      sideX: placement.sideX,
      sideY: placement.sideY,
    });
  };

  return (
    <div className="generator-fuel-trend">
      <div className="generator-fuel-trend-head">
        <span>{t("fuelTrendEstimatedConsumption")}</span>
        <strong>{mode === "both" ? "% / L" : mode === "liters" ? t("fuelTrendLiters") : t("fuelTrendLevel")}</strong>
      </div>
      {tooltip ? (
        <div
          className={`generator-chart-tooltip generator-chart-tooltip-fuel ${tooltip.sideX === "left" ? "flip-x" : ""} ${tooltip.sideY === "bottom" ? "flip-y" : ""}`}
          style={{ left: tooltip.x, top: tooltip.y }}
        >
          {tooltip.text}
        </div>
      ) : null}
      <svg
        viewBox={`0 0 ${width} ${height}`}
        className="generator-fuel-trend-svg"
        aria-hidden="true"
        onMouseMove={handleMove}
        onMouseLeave={() => setTooltip(null)}
      >
        {leftTicks.map((tick) => {
          const y = top + (1 - tick / 100) * innerHeight;

          return (
            <g key={`fuel-y-${tick}`}>
              <line x1={left} y1={y} x2={width - right} y2={y} className="generator-fuel-grid-line" />
              <text x={left - 6} y={y + 3} textAnchor="end" className="generator-fuel-axis-label left">
                {tick}
              </text>
            </g>
          );
        })}

        {rightTicks.map((tick) => {
          const y = top + (1 - (tick / maxLiters)) * innerHeight;

          return (
            <text key={`fuel-r-${tick}`} x={width - right + 6} y={y + 3} textAnchor="start" className="generator-fuel-axis-label right">
              {tick}
            </text>
          );
        })}

        {coords.map((point) => (
          <g key={`fuel-x-${point.id}`}>
            <line x1={point.x} y1={top} x2={point.x} y2={height - bottom} className="generator-fuel-grid-guide" />
            <text x={point.x} y={height - 6} textAnchor="middle" className="generator-fuel-axis-label">
              {point.label}
            </text>
          </g>
        ))}

        {showPercentage ? <polyline points={percentagePolyline} className="generator-fuel-line percentage" /> : null}
        {showLiters ? <polyline points={litersPolyline} className="generator-fuel-line liters" /> : null}

        {coords.map((point) => (
          <g key={`fuel-point-p-${point.id}`}>
            {showPercentage ? <circle cx={point.x} cy={point.percentageY} r="3.2" className="generator-fuel-point percentage" /> : null}
            {showLiters ? <circle cx={point.x} cy={point.litersY} r="2.8" className="generator-fuel-point liters" /> : null}
          </g>
        ))}
      </svg>
    </div>
  );
}

function FuelStatusCard({ level = 0, consumption = 0, days = 0, hours = 0, minutes = 0, timestamp = "--", t }) {
  const safeLevel = Math.max(0, Math.min(100, toFiniteNumber(level, 0)));
  const safeConsumption = toFiniteNumber(consumption, 0);
  const safeDays = Math.max(0, toFiniteNumber(days, 0));
  const safeHours = Math.max(0, toFiniteNumber(hours, 0));
  const safeMinutes = Math.max(0, toFiniteNumber(minutes, 0));
  const fuelTone = safeLevel <= 15 ? "critical" : safeLevel <= 40 ? "warn" : "healthy";
  const fuelStatus = safeLevel <= 15
    ? t("fuelStatusCritical")
    : safeLevel <= 40
      ? t("fuelStatusReserve")
      : t("fuelStatusStable");
  const fuelStatusTooltip = t("fuelStatusTooltip");

  return (
    <article className="generator-fuel-card">
      <div className="generator-panel-title">
        {t("fuel")}
      </div>
      <div className="generator-fuel-body">
        <div className="generator-fuel-visual">
          <div className={`generator-fuel-tank tone-${fuelTone}`}>
            <div className="generator-fuel-tank-cap" />
            <div className="generator-fuel-tank-shell">
              <div className="generator-fuel-tank-scale">
                {[100, 75, 50, 25, 0].map((mark) => (
                  <span key={mark}>{mark}</span>
                ))}
              </div>
              <div className="generator-fuel-fill-track">
                <div className="generator-fuel-fill" style={{ height: `${safeLevel}%` }} />
              </div>
            </div>
          </div>

          <div className="generator-fuel-summary">
            <div className="generator-fuel-summary-top">
              <div className="generator-fuel-stat primary">
                <span>{t("currentLevel")}</span>
                <strong>{safeLevel}%</strong>
              </div>

              <div className="generator-fuel-stat">
                <span>{t("estimatedAutonomy")}</span>
                <strong>{formatDurationCompact({ days: safeDays, hours: safeHours, minutes: safeMinutes }, t)}</strong>
              </div>
            </div>

            <div className="generator-fuel-summary-meta">
              <div className="generator-fuel-chip">
                <span>{t("totalConsumption")}</span>
                <strong>{formatValue("Consumo total de combustible", safeConsumption, t)}</strong>
              </div>

              <div className={`generator-fuel-chip status tone-${fuelTone}`}>
                <span className="generator-fuel-chip-label">
                  {t("status")}
                  <button
                    type="button"
                    className="generator-fuel-info"
                    title={fuelStatusTooltip}
                    aria-label={fuelStatusTooltip}
                  >
                    i
                  </button>
                </span>
                <strong>{fuelStatus}</strong>
              </div>
            </div>

            <div className="generator-fuel-autonomy-detail">
              <small>
                {/* {safeDays} dias - {safeHours} horas - {safeMinutes} min */}
              </small>
            </div>
          </div>
        </div>

        {/* <div className="generator-fuel-trend-shell">
          <div className="generator-fuel-trend-toolbar">
            <span>Tendencia de combustible</span>
            <div className="generator-fuel-trend-modes">
              {[
                { id: "percentage", label: "%" },
                { id: "liters", label: "L" },
                { id: "both", label: "Ambos" },
              ].map((option) => (
                <button
                  key={option.id}
                  type="button"
                  className={`generator-fuel-trend-mode ${trendMode === option.id ? "active" : ""}`}
                  onClick={() => setTrendMode(option.id)}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>

          <FuelTrendChart points={trendPoints} mode={trendMode} />
        </div> */}

        <small className="generator-fuel-timestamp">
          {formatDurationCompact({ days: safeDays, hours: safeHours, minutes: safeMinutes }, t)}
        </small>
      </div>
    </article>
  );
}

function KwGauge({ value = 0, max = 250, rpm = 0, pf = 0, battery = 0 }) {
  const safeValue = Math.max(0, toFiniteNumber(value, 0));
  const clamped = Math.min(safeValue, max);
  const startAngle = -132;
  const sweepAngle = 264;
  const angle = startAngle + (clamped / max) * sweepAngle;

  const centerX = 122;
  const centerY = 116;
  const outerTickInner = 78;
  const outerTickOuter = 88;
  const labelRadius = 101;
  const colorRadius = 68;
  const faceRadius = 20;

  const pointerBase = polarToCartesian(centerX, centerY, 12, angle + 180);
  const pointerTip = polarToCartesian(centerX, centerY, 78, angle);

  const scaleTicks = [0, 25, 50, 75, 100, 125, 150, 175, 200, 225, 250];

  return (
    <article className="generator-gauge-card">
      <div className="generator-gauge-wrap">
        <svg
          viewBox="0 0 270 220"
          className="generator-gauge-svg"
          preserveAspectRatio="xMidYMid meet"
          aria-hidden="true"
        >
          {scaleTicks.map((tick) => {
            const tickAngle = startAngle + (tick / max) * sweepAngle;
            const outer = polarToCartesian(centerX, centerY, outerTickOuter, tickAngle);
            const inner = polarToCartesian(centerX, centerY, outerTickInner, tickAngle);
            const label = polarToCartesian(centerX, centerY, labelRadius, tickAngle);

            return (
              <g key={`tick-${tick}`}>
                <line
                  x1={inner.x}
                  y1={inner.y}
                  x2={outer.x}
                  y2={outer.y}
                  className="generator-gauge-tick"
                />
                <text
                  x={label.x}
                  y={label.y}
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="generator-gauge-label"
                >
                  {tick}
                </text>
              </g>
            );
          })}

          <path
            d={describeArc(centerX, centerY, colorRadius, startAngle, startAngle + 170)}
            className="generator-gauge-band green"
          />
          <path
            d={describeArc(centerX, centerY, colorRadius, startAngle + 170, startAngle + 192)}
            className="generator-gauge-band yellow"
          />
          <path
            d={describeArc(centerX, centerY, colorRadius, startAngle + 192, startAngle + sweepAngle)}
            className="generator-gauge-band red"
          />

          <path
            d={describeArc(centerX, centerY, colorRadius - 1.2, startAngle + 8, startAngle + 164)}
            className="generator-gauge-band-inner green"
          />
          <path
            d={describeArc(centerX, centerY, colorRadius - 1.2, startAngle + 198, startAngle + sweepAngle - 8)}
            className="generator-gauge-band-inner red"
          />

          <ellipse cx={centerX} cy="215" rx="18" ry="2.6" className="generator-gauge-base-shadow" />

          <line
            x1={pointerBase.x}
            y1={pointerBase.y}
            x2={pointerTip.x}
            y2={pointerTip.y}
            className="generator-gauge-pointer-shadow"
          />
          <line
            x1={pointerBase.x}
            y1={pointerBase.y}
            x2={pointerTip.x}
            y2={pointerTip.y}
            className="generator-gauge-pointer"
          />
          <line
            x1={centerX}
            y1={centerY}
            x2={pointerBase.x}
            y2={pointerBase.y}
            className="generator-gauge-pointer-tail"
          />
          <circle cx={centerX} cy={centerY} r={faceRadius} className="generator-gauge-face" />

          <text x={centerX} y="190" textAnchor="middle" className="generator-gauge-readout">
            {clamped}
          </text>
          <text x={centerX} y="209" textAnchor="middle" className="generator-gauge-unit">
            kW
          </text>
        </svg>
      </div>
    </article>
  );
}

export default function GenerarView({
  generadores = [],
  generatorData,
  lastUpdate,
  selectedGeneratorKey: preferredGeneratorKey,
  translate,
  t: legacyT,
  tm: legacyTm,
}) {

  // console.log('generatorData',generatorData)
  // const { t, tm } = useI18n();
  const mainRef = useRef(null);
  const detailRef = useRef(null);
  const firstDetailCardRef = useRef(null);
  const t = React.useCallback(
    (key, params = undefined) => {
      const aliasKey = key === "generator" ? "title" : key;
      const translated = pickResolvedTranslation([
        {
          value: typeof legacyT === "function" ? legacyT(key, params) : undefined,
          misses: [key, aliasKey],
        },
        {
          value: typeof translate === "function" ? translate(key) : undefined,
          misses: [key],
        },
        {
          value: typeof translate === "function" ? translate(aliasKey) : undefined,
          misses: [aliasKey],
        },
      ]);

      const fallback = getNestedFallback(`ui.${aliasKey}`) ?? getNestedFallback(key) ?? aliasKey;
      const resolved = translated && translated !== key ? translated : fallback;
      return interpolateTemplate(resolved, params);
    },
    [legacyT, translate]
  );
  const tm = React.useCallback(
    (namespace, key, params = undefined, fallback = key) => {
      const dottedKey = `${namespace}.${key}`;
      const normalizedNamespace = namespace.startsWith("generator.")
        ? namespace.slice("generator.".length)
        : namespace;
      const normalizedDottedKey = `${normalizedNamespace}.${key}`;
      const translated = pickResolvedTranslation([
        {
          value: typeof legacyTm === "function" ? legacyTm(namespace, key, params, fallback) : undefined,
          misses: [dottedKey, normalizedDottedKey, key, fallback],
        },
        {
          value: typeof translate === "function" ? translate(key) : undefined,
          misses: [key],
        },
        {
          value: typeof translate === "function" ? translate(dottedKey) : undefined,
          misses: [dottedKey],
        },
        {
          value: typeof translate === "function" ? translate(normalizedDottedKey) : undefined,
          misses: [normalizedDottedKey],
        },
      ]);

      const namespacedFallback =
        getNestedFallback(normalizedDottedKey) ??
        getNestedFallback(dottedKey);
      const resolved = translated ?? namespacedFallback ?? fallback;
      return interpolateTemplate(resolved, params);
    },
    [legacyTm, translate]
  );
  const generatorEntries = React.useMemo(() => {
    if (generatorData?.generators && typeof generatorData.generators === "object") {
      return Object.entries(generatorData.generators);
    }

    if (generatorData && typeof generatorData === "object") {
      return [["generator_1", generatorData]];
    }

    return [];
  }, [generatorData]);

  const [selectedGeneratorKey, setSelectedGeneratorKey] = useState(
    generatorEntries[0]?.[0] || "generator_1"
  );
  const [favoriteLabels, setFavoriteLabels] = useState(DEFAULT_FAVORITE_LABELS);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [draggedFavorite, setDraggedFavorite] = useState(null);
  const [dragOverFavorite, setDragOverFavorite] = useState(null);
  const [draggedSection, setDraggedSection] = useState(null);
  const [dragOverSection, setDragOverSection] = useState(null);
  const [preferencesHydrated, setPreferencesHydrated] = useState(false);
  const selectableLabels = React.useMemo(
    () => Array.from(new Set(SECTION_DEFINITIONS.flatMap((section) => section.items))),
    []
  );
  const availableSectionTitles = React.useMemo(
    () => SECTION_DEFINITIONS.map((section) => section.title),
    []
  );
  const [sectionOrder, setSectionOrder] = useState(availableSectionTitles);

  React.useEffect(() => {
    if (!generatorEntries.length) return;

    const preferredExists = preferredGeneratorKey
      ? generatorEntries.some(([key]) => key === preferredGeneratorKey)
      : false;
    const currentExists = generatorEntries.some(([key]) => key === selectedGeneratorKey);
    const nextKey = preferredExists
      ? preferredGeneratorKey
      : currentExists
      ? selectedGeneratorKey
      : generatorEntries[0][0];

    if (nextKey !== selectedGeneratorKey) {
      setSelectedGeneratorKey(nextKey);
    }
  }, [generatorEntries, preferredGeneratorKey, selectedGeneratorKey]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    setPreferencesHydrated(false);

    let nextFavorites = DEFAULT_FAVORITE_LABELS;
    let nextSectionOrder = availableSectionTitles;

    try {
      const storedKpis = JSON.parse(window.localStorage.getItem(KPI_STORAGE_KEY) || "{}");
      const generatorSpecificKpis = storedKpis?.[selectedGeneratorKey];
      nextFavorites = sanitizeFavoriteLabels(generatorSpecificKpis, selectableLabels);
    } catch {
      nextFavorites = sanitizeFavoriteLabels(DEFAULT_FAVORITE_LABELS, selectableLabels);
    }

    try {
      const storedDetail = JSON.parse(window.localStorage.getItem(DETAIL_STORAGE_KEY) || "{}");
      const generatorSpecificOrder = storedDetail?.[selectedGeneratorKey];
      nextSectionOrder = sanitizeSectionOrder(generatorSpecificOrder, availableSectionTitles);
    } catch {
      nextSectionOrder = availableSectionTitles;
    }

    setFavoriteLabels(nextFavorites);
    setSectionOrder(nextSectionOrder);

    const frame = window.requestAnimationFrame(() => {
      setPreferencesHydrated(true);
    });

    return () => window.cancelAnimationFrame(frame);
  }, [selectedGeneratorKey, selectableLabels, availableSectionTitles]);

  useEffect(() => {
    if (typeof window === "undefined" || !preferencesHydrated) return;

    try {
      const stored = JSON.parse(window.localStorage.getItem(KPI_STORAGE_KEY) || "{}");
      stored[selectedGeneratorKey] = sanitizeFavoriteLabels(favoriteLabels, selectableLabels);
      window.localStorage.setItem(KPI_STORAGE_KEY, JSON.stringify(stored));
    } catch {
      // ignore persistence errors
    }
  }, [favoriteLabels, selectedGeneratorKey, selectableLabels, preferencesHydrated]);

  useEffect(() => {
    if (typeof window === "undefined" || !preferencesHydrated) return;

    try {
      const stored = JSON.parse(window.localStorage.getItem(DETAIL_STORAGE_KEY) || "{}");
      stored[selectedGeneratorKey] = sanitizeSectionOrder(sectionOrder, availableSectionTitles);
      window.localStorage.setItem(DETAIL_STORAGE_KEY, JSON.stringify(stored));
    } catch {
      // ignore persistence errors
    }
  }, [sectionOrder, selectedGeneratorKey, availableSectionTitles, preferencesHydrated]);

  useEffect(() => {
    if (!detailsOpen) return;

    const timer = window.setTimeout(() => {
      const detailSection = detailRef.current;

      if (!detailSection) return;

      detailSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }, 80);

    return () => window.clearTimeout(timer);
  }, [detailsOpen]);

  const activeGenerator = React.useMemo(() => {
    const selectedEntry = generatorEntries.find(([key]) => key === selectedGeneratorKey);
    return selectedEntry?.[1] || null;
  }, [generatorEntries, selectedGeneratorKey]);

  const activeGeneratorRecord = React.useMemo(() => {
    return resolveGeneratorRecord(activeGenerator);
  }, [activeGenerator]);

  const dataset = buildDataset(activeGeneratorRecord);

  const kpiCards = buildKpiCards(dataset, favoriteLabels, (label, value) => formatValue(label, value, t));
  const translateLabel = React.useCallback(
    (label) => tm("generator.labels", label, undefined, label),
    [tm]
  );
  const translateSectionTitle = React.useCallback(
    (title) => {
      const sectionTitleKey = SECTION_TITLE_TRANSLATION_KEYS[title];

      return pickResolvedTranslation([
        {
          value: sectionTitleKey && typeof translate === "function" ? translate(sectionTitleKey) : undefined,
          misses: [sectionTitleKey],
        },
        {
          value: tm("generator.sections", title, undefined, title),
          misses: [title],
        },
      ]) ?? title;
    },
    [tm, translate]
  );
  const translateSectionDescription = React.useCallback(
    (title, fallback) => tm("generator.sectionDescriptions", title, undefined, fallback),
    [tm]
  );
  const translateHelper = React.useCallback(
    (helper) => (helper ? tm("generator.helpers", helper, undefined, helper) : ""),
    [tm]
  );

  const connected = getValue(dataset, "connected") === true;
  const fuelLevel = getValue(dataset, "Fuel level");
  const rpm = getValue(dataset, "RPM");
  const battery = getValue(dataset, "Voltaje de la bateria");
  const totalGeneradores = generatorEntries.length || (Array.isArray(generadores) ? generadores.length : 0);
  const phnValues = [
    getValue(dataset, "Voltaje de generador L1-N"),
    getValue(dataset, "Voltaje de generador L2-N"),
    getValue(dataset, "Voltaje de generador L3-N"),
  ];
  const phphValues = [
    getValue(dataset, "Voltaje de generador L1-L2"),
    getValue(dataset, "Voltaje de generador L2-L3"),
    getValue(dataset, "Voltaje de generador L3-L1"),
  ];
  const currentValues = [
    getValue(dataset, "Corriente de carga L1"),
    getValue(dataset, "Corriente de carga L2"),
    getValue(dataset, "Corriente de carga L3"),
  ];
  const kwValue = getValue(dataset, "P Carga");
  const fuelDays = getValue(dataset, "Tiempo hasta Vaciarce(Dias)");
  const fuelHours = getValue(dataset, "Tiempo hasta Vaciarce(hrs)");
  const fuelMinutes = getValue(dataset, "Tiempo hasta Vaciarce(min)");
  const totalFuelConsumption = getValue(dataset, "Consumo total de combustible");
  const horasEjecucion = getValue(dataset, "Horas en Ejecucion");
  const ecuCommFail = getValue(dataset, "ECU Comm Fail") === true;
  const stateItems = [
    { label: "Comunicacion",         value: connected,                                        helper: "Enlace con el controlador" },
    { label: "En Marcha",            value: getValue(dataset, "En Marcha") === true,          helper: "Generador encendido" },
    { label: "Ejecutando",           value: getValue(dataset, "Ejecutando") === true,         helper: "Proceso de arranque" },
    { label: "Generador OK",         value: getValue(dataset, "Generador OK") === true,       helper: "Condicion general del grupo" },
    { label: "Red OK",               value: getValue(dataset, "Red OK") === true,             helper: "Disponibilidad de red" },
    { label: "Alimentando carga",    value: getValue(dataset, "Alimentando carga") === true,  helper: "Entregando energia a la carga" },
    { label: "Enfriando",            value: getValue(dataset, "Enfriando") === true,          helper: "Post parada y enfriamiento" },
    { label: "Listo",                value: getValue(dataset, "Listo") === true,              helper: "Disponible para operar" },
    { label: "Listo para AMF",       value: getValue(dataset, "Listo para AMF") === true,     helper: "Preparado para transferencia" },
    { label: "Listo Para Cargar",    value: getValue(dataset, "Listo Para Cargar") === true,  helper: "Listo para energizar carga" },
    { label: "No en Auto",           value: getValue(dataset, "No en Auto") === true,         helper: "Fuera de modo automatico" },
    { label: "ECU OK",               value: getValue(dataset, "Comunicacion ECU OK") === true, helper: "Comunicacion ECU correcta" },
    { label: "ECU Rele Potencia",    value: getValue(dataset, "ECU Relé de Potencia") === true, helper: "Rele ECU activo" },
    { label: "ECU espera Start",     value: getValue(dataset, "ECU Esperar para Start") === true, helper: "Esperando arranque" },
    { label: "Falla Comun Modulo periférico",     value: getValue(dataset, "Falla Comun Modulo periférico") === true, helper: "..." },
    { label: "Frecuencia Generador", value: getValue(dataset, "Frecuencia Generador") === true },
    { label: "Frecuencia Red",       value: getValue(dataset, "Frecuencia Red") === true },

  ];
  const modeItems = [
    { label: "Modo OFF", value: getValue(dataset, "Modo OFF") === true },
    { label: "Modo MAN", value: getValue(dataset, "Modo MAN") === true },
    { label: "Modo TEST", value: getValue(dataset, "Modo TEST") === true },
    { label: "Modo AUTO", value: getValue(dataset, "Modo AUTO") === true },
  ];
  const alarmItems = [
    { label: "Alarma", value: getValue(dataset, "Alarma") === true },
    { label: "Sirena", value: getValue(dataset, "Sirena") === true },
    { label: "Fallo de Red", value: getValue(dataset, "Fallo de Red") === true },
    { label: "Voltaje Red", value: getValue(dataset, "Voltaje Red") === true },
    { label: "Frecuencia Red", value: getValue(dataset, "Frecuencia Red") === true },
    { label: "Frecuencia Generador", value: getValue(dataset, "Frecuencia Generador") === true },
    { label: "Alarma Nivel 1", value: getValue(dataset, "Alarma Nivel 1") === true },
    { label: "Alarma Nivel 2", value: getValue(dataset, "Alarma Nivel 2") === true },
    { label: "AL Gen Frec WRN", value: getValue(dataset, "AL Gen Frec WRN") === true },
    { label: "AL Gen Frecuencia", value: getValue(dataset, "AL Gen Frecuencia") === true },
    { label: "AL Fallo de Red", value: getValue(dataset, "AL Fallo de Red") === true },
    { label: "AL Frecuencia Red", value: getValue(dataset, "AL Frecuencia Red") === true },
    { label: "AL Voltaje de red", value: getValue(dataset, "AL Voltaje de red") === true },
    { label: "AL comun WRN", value: getValue(dataset, "AL común WRN") === true },
    { label: "AL comun BOC", value: getValue(dataset, "AL común BOC") === true },
    { label: "AL comun FLS", value: getValue(dataset, "AL común FLS") === true },
    { label: "E-STOP", value: getValue(dataset, "E-STOP") === true },
    
  ];

  const toggleFavorite = (label) => {
    setFavoriteLabels((prev) => (
      prev.includes(label)
        ? prev.filter((item) => item !== label)
        : [...prev, label]
    ));
  };

  const moveFavorite = (fromLabel, toLabel) => {
    if (!fromLabel || !toLabel || fromLabel === toLabel) return;

    setFavoriteLabels((prev) => {
      const fromIndex = prev.indexOf(fromLabel);
      const toIndex = prev.indexOf(toLabel);

      if (fromIndex === -1 || toIndex === -1) return prev;

      const next = [...prev];
      [next[fromIndex], next[toIndex]] = [next[toIndex], next[fromIndex]];
      return next;
    });
  };

  const handleFavoriteDragEnter = (targetLabel) => {
    if (!draggedFavorite || draggedFavorite === targetLabel) return;
    setDragOverFavorite(targetLabel);
  };

  const orderedSections = React.useMemo(
    () => sectionOrder
      .map((title) => SECTION_DEFINITIONS.find((section) => section.title === title))
      .filter(Boolean),
    [sectionOrder]
  );

  const moveSection = (fromTitle, toTitle) => {
    if (!fromTitle || !toTitle || fromTitle === toTitle) return;

    setSectionOrder((prev) => {
      const fromIndex = prev.indexOf(fromTitle);
      const toIndex = prev.indexOf(toTitle);

      if (fromIndex === -1 || toIndex === -1) return prev;

      const next = [...prev];
      [next[fromIndex], next[toIndex]] = [next[toIndex], next[fromIndex]];
      return next;
    });
  };

  const handleSectionDragEnter = (targetTitle) => {
    if (!draggedSection || draggedSection === targetTitle) return;
    setDragOverSection(targetTitle);
  };

  // Un centro sin bloque COMAP no debe pintar el tablero completo en "--":
  // se explica que todavia no hay lecturas del generador.
  if (!generatorEntries.length) {
    return (
      <section className="generator-dashboard">
        <div className="generator-main" ref={mainRef}>
          <div className="generator-topbar">
            <div>
              <h2 className="generator-title">{t("generator")}</h2>
            </div>
          </div>

          <article className="generator-operational-card">
            <div className="generator-operational-head">
              <div>
                <h3>{t("noGeneratorsTitle")}</h3>
                <p>{t("noGeneratorsSummary")}</p>
              </div>
            </div>
          </article>
        </div>
      </section>
    );
  }

  return (
    <section className="generator-dashboard">
      <div className="generator-main" ref={mainRef}>
        <div className="generator-topbar">
          <div>
            <h2 className="generator-title">{t("generator")}</h2>
          </div>

          <div className="generator-topbar-meta">
            <span>{t("detectedGenerators", { count: totalGeneradores })}</span>
            {generatorEntries.length > 1 && (
              <div className="generator-selector">
                {generatorEntries.map(([key]) => (
                  <button
                    key={key}
                    type="button"
                    className={`generator-selector-button ${selectedGeneratorKey === key ? "active" : ""}`}
                    onClick={() => setSelectedGeneratorKey(key)}
                  >
                    {key.replace("_", " ")}
                  </button>
                ))}
              </div>
            )}
            <button
              type="button"
              className={`generator-view-menu-trigger ${detailsOpen ? "active" : ""}`}
              onClick={() => setDetailsOpen((prev) => !prev)}
            >
              {detailsOpen ? t("hideDetail") : t("showDetail")}
            </button>
          </div>
        </div>

        {/* <div className={`generator-content-layout ${detailsOpen ? "with-details" : ""}`}> */}
          <div className="generator-content-main">
            <section className={`generator-kpi-grid ${draggedFavorite ? "is-sorting" : ""}`}>
              {kpiCards.map((card) => (
                <article
                  className={`generator-kpi accent-${card.accent} ${draggedFavorite === card.label ? "is-dragging" : ""} ${dragOverFavorite === card.label ? "is-drag-target" : ""}`}
                  key={card.label}
                  draggable
                  onDragStart={() => setDraggedFavorite(card.label)}
                  onDragEnter={() => handleFavoriteDragEnter(card.label)}
                  onDragOver={(event) => event.preventDefault()}
                  onDrop={() => {
                    if (draggedFavorite && draggedFavorite !== card.label) {
                      moveFavorite(draggedFavorite, card.label);
                    }
                    setDraggedFavorite(null);
                    setDragOverFavorite(null);
                  }}
                  onDragEnd={() => {
                    setDraggedFavorite(null);
                    setDragOverFavorite(null);
                  }}
                >
                  <p className="generator-kpi-label">{translateLabel(card.label)}</p>
                  <p className="generator-kpi-value">{card.value}</p>
                  <small>{formatNanooxTimestamp(card.timestamp)}</small>
                </article>
              ))}
            </section>

            <GeneratorOperationalOverview
              connected={connected}
              hours={horasEjecucion}
              stateItems={stateItems}
              modeItems={modeItems}
              alarmItems={alarmItems}
              ecuCommFail={ecuCommFail}
              t={t}
              translateLabel={translateLabel}
              translateHelper={translateHelper}
            />

            <section className="generator-visual-grid">
              <FuelStatusCard
                level={fuelLevel}
                consumption={totalFuelConsumption}
                days={fuelDays}
                hours={fuelHours}
                minutes={fuelMinutes}
                timestamp={formatNanooxTimestamp(
                  getTimestamp(dataset, "Consumo total de combustible")
                )}
                t={t}
              />
              <MiniPhaseChart
                title={t("phnVoltage")}
                labels={["L1-N", "L2-N", "L3-N"]}
                values={phnValues}
                max={400}
              />
              <MiniPhaseChart
                title={t("phphVoltage")}
                labels={["L1-L2", "L2-L3", "L3-L1"]}
                values={phphValues}
                max={600}
              />
              <MiniPhaseChart
                title={t("currentChart")}
                labels={["L1", "L2", "L3"]}
                values={currentValues}
                max={400}
              />
              <KwGauge
                value={kwValue}
                rpm={rpm}
                pf={getValue(dataset, "Factor de potencia de carga")}
                battery={battery}
              />
            </section>
          {/* </div> */}

        {detailsOpen ? <aside className="generator-content-detail" ref={detailRef}><section className={`generator-tables-grid ${draggedSection ? "is-sorting" : ""}`}>
          {orderedSections.map((section) => {
            const meta = SECTION_META[section.title] || { icon: "*", accent: "slate", description: t("operationalSummary") };
            return (
            <article
              className={`generator-section-card accent-${meta.accent} ${draggedSection === section.title ? "is-dragging" : ""} ${dragOverSection === section.title ? "is-drag-target" : ""}`}
              key={section.title}
              ref={firstDetailCardRef.current ? null : firstDetailCardRef}
              draggable
              onDragStart={() => setDraggedSection(section.title)}
              onDragEnter={() => handleSectionDragEnter(section.title)}
              onDragOver={(event) => event.preventDefault()}
              onDrop={() => {
                if (draggedSection && draggedSection !== section.title) {
                  moveSection(draggedSection, section.title);
                }
                setDraggedSection(null);
                setDragOverSection(null);
              }}
              onDragEnd={() => {
                setDraggedSection(null);
                setDragOverSection(null);
              }}
            >
              <div className="generator-section-head">
                <div className="generator-section-heading">
                  <span className={`generator-section-icon accent-${meta.accent}`}>{meta.icon}</span>
                  <div>
                    <h3 className="generator-section-title">{translateSectionTitle(section.title)}</h3>
                    <p className="generator-section-description">{translateSectionDescription(section.title, meta.description)}</p>
                  </div>
                </div>
                <div className="generator-section-meta">
                  <p className="generator-section-timestamp">
                    {t("updated", {
                      value: formatNanooxTimestamp(
                        getSectionTimestamp(dataset, section.items)
                      ),
                    })}
                  </p>
                  <span className="generator-section-count">{section.items.length}</span>
                </div>
              </div>

              {/* <div className="generator-section-highlights">
                {highlights.map((item) => (
                  <div
                    className={`generator-section-highlight`}

                    key={`${section.title}-${item.label}`}
                  >
                    <span>{item.label}</span>
                    <strong>{item.value}</strong>
                  </div>
                ))}
              </div> */}

              <div className="generator-section-list">
                {section.items.map((label) => (
                  <div className="generator-section-row" key={label}>
                    <span>{translateLabel(label)}</span>
                    <div className="generator-section-row-actions">
                      <strong>{formatValue(label, getValue(dataset, label), t)}</strong>
                      <button
                        type="button"
                        className={`generator-favorite-button ${favoriteLabels.includes(label) ? "active" : ""}`}
                        onClick={() => toggleFavorite(label)}
                        aria-label={t("favorite", { label: translateLabel(label) })}
                      >
                        ★
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </article>
          );
          })}
        </section></aside> : null}
        </div>
      </div>
    </section>
  );
}
